import React from "react";
import { NavigatorIcon, defaultLogo } from "../../Assets/Icons";

const UnoAppsPopover = ({ applications = [], onAppClick = null }) => {
  const handleAppClick = (value) => {
    if (onAppClick) {
      onAppClick(value);
    }
  };

  return (
    <div className="dropdown navigator">
      <div className="profile-info dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        <NavigatorIcon />
      </div>
      <div className="dropdown-menu">
        <div className="menu-long">
          <div className={applications.length > 2 ? "menubg extraspace" : "menubg"}>
            {applications.map((e) => {
              return (
                <div key={e?.uuid} className="appshere" onClick={() => handleAppClick(e)}>
                  <img
                    src={e?.icon || defaultLogo}
                    onError={(e) => {
                      e.target.src = `${defaultLogo}`;
                      e.onerror = null;
                    }}
                    alt=""
                    referrerPolicy={"no-referrer"}
                  />
                  <p>{e?.name}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnoAppsPopover;
